document.addEventListener("DOMContentLoaded", function() {

  function parsePriceString(raw) {
    if (!raw) return NaN;
    var s = String(raw).replace(/[^\d.,]/g, '').trim();
    if (!s) return NaN;
    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        s = s.replace(/\./g, '');
        s = s.replace(',', '.');
      } else {
        s = s.replace(/,/g, '');
      }
    } else if (lastComma > -1) {
      var commas = (s.match(/,/g) || []).length;
      if (commas > 1) s = s.replace(/,/g, '');
      else s = s.replace(',', '.');
    } else if (lastDot > -1) {
      var dots = (s.match(/\./g) || []).length;
      if (dots > 1) s = s.replace(/\./g, '');
    }
    var num = parseFloat(s);
    return isNaN(num) ? NaN : num;
  }

  function addDiscountInfo() {
    document.querySelectorAll(".product-block__detail").forEach(function(detailBlock) {
      if (detailBlock.dataset.discountAdded) return; // Daha önce eklenmişse atla

      var priceElement = detailBlock.querySelector(".js-value");
      var wrapper = detailBlock.closest(".block-inner-inner");
      var labelEl = wrapper ? wrapper.querySelector(".label-text-hamsa") : null;

      // Eğer öğeler henüz gelmemişse bekle
      if (!priceElement || !labelEl) return;

      var match = (labelEl.textContent || "").match(/%(\d{1,3})/);
      if (!match) return;

      var discountPercent = parseInt(match[1], 10);
      if (isNaN(discountPercent) || discountPercent <= 0) return;

      var price = parsePriceString(priceElement.textContent || "");
      if (isNaN(price) || price <= 0) return;

      var discounted = price * (1 - discountPercent / 100);
      var formatted = discounted.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      var discountInfo = document.createElement("div");
      discountInfo.className = "discount-info";
      discountInfo.innerHTML = `💖 <strong>Sepette %${discountPercent} indirim:</strong> ${formatted} TL`;

      Object.assign(discountInfo.style, {
        backgroundColor: "#fde8f0",
        color: "#5a2a47",
        fontWeight: "600",
        fontFamily: "'Poppins', 'Arial', sans-serif",
        padding: "6px 10px",
        borderRadius: "6px",
        fontSize: "14px",
        marginTop: "8px",
        textAlign: "center",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
      });

      var priceBlock = detailBlock.querySelector(".product-price");
      if (priceBlock) priceBlock.appendChild(discountInfo);

      detailBlock.dataset.discountAdded = "true"; // Tekrar eklemeyi önlemek için işaretle
    });
  }

  addDiscountInfo();

  // Yeni eklenen ürünleri sürekli kontrol eden interval
  setInterval(addDiscountInfo, 500);

  // Ayrıca ürün konteynerini gözlemle, DOM değiştiğinde hemen kontrol et
  const productContainer = document.querySelector(".product-grid, .collection-products, .products, .product-list, #Collection, #MainContent");
  if (productContainer) {
    const observer = new MutationObserver(() => {
      setTimeout(addDiscountInfo, 100); // kısa gecikme ile yeni ürünleri yakala
    });
    observer.observe(productContainer, { childList: true, subtree: true });
  }




// burası ürün detay kodları
  if (typeof ShopifyAnalytics !== "undefined" && ShopifyAnalytics.meta?.page?.pageType === "product") {

   // Her 200ms'de kontrol edip gizle
const hideMessageInterval = setInterval(() => {
  const messages = document.querySelectorAll('.layout.layout1 .message-hamsa.wizz-message');
  messages.forEach(msg => {
    if (msg.style.display !== 'none') {
      msg.style.display = 'none';
    }
  });
}, 200);

setTimeout(() => clearInterval(hideMessageInterval), 10000);

    function parsePriceString(raw) {
      if (!raw) return NaN;
      var s = String(raw).replace(/[^\d.,]/g, '').trim();
      if (!s) return NaN;
      var lastComma = s.lastIndexOf(',');
      var lastDot = s.lastIndexOf('.');

      if (lastComma > -1 && lastDot > -1) {
        if (lastComma > lastDot) {
          s = s.replace(/\./g, '');
          s = s.replace(',', '.');
        } else {
          s = s.replace(/,/g, '');
        }
      } else if (lastComma > -1) {
        var commas = (s.match(/,/g) || []).length;
        if (commas > 1) s = s.replace(/,/g, '');
        else s = s.replace(',', '.');
      } else if (lastDot > -1) {
        var dots = (s.match(/\./g) || []).length;
        if (dots > 1) s = s.replace(/\./g, '');
      }
      var num = parseFloat(s);
      return isNaN(num) ? NaN : num;
    }

    function addDiscountSingleProduct() {
      var priceEl = document.querySelector("#product-price");
      var messageEl = document.querySelector("#message-price");

      if (!priceEl || !messageEl) return;
      if (priceEl.dataset.discountAdded) return; // tekrar eklemeyi önlemek

      var match = messageEl.textContent.match(/%(\d{1,3})/);
      if (!match) return;

      var discountPercent = parseInt(match[1], 10);
      if (isNaN(discountPercent) || discountPercent <= 0) return;

      var price = parsePriceString(priceEl.textContent);
      if (isNaN(price) || price <= 0) return;

      var discounted = price * (1 - discountPercent / 100);
      var formatted = discounted.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      var discountInfo = document.createElement("div");
      discountInfo.className = "discount-info-single";
      discountInfo.innerHTML = `💖 <strong>Sepette %${discountPercent} indirim:</strong> ${formatted} TL`;

      Object.assign(discountInfo.style, {
        backgroundColor: "#fde8f0",
        color: "#5a2a47",
        fontWeight: "600",
        fontFamily: "'Poppins', 'Arial', sans-serif",
        padding: "6px 10px",
        borderRadius: "6px",
        fontSize: "14px",
        marginTop: "8px",
        textAlign: "center",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "inline-block"
      });



      priceEl.parentNode.appendChild(discountInfo);

      priceEl.dataset.discountAdded = "true";
    }

    addDiscountSingleProduct();
    setInterval(addDiscountSingleProduct, 500);

  }


});
